define((require) => {
    "use strict";

    const Backbone        = require("backbone");
    const StatsDAnalytics = require("shared/services/tracker/StatsDAnalytics");
    const LoggedIn        = require("shared/security/LoggedIn");
    const EventDispatcher = require("shared/util/EventDispatcher");
    /**
     * StatsD analytics for the editor.
     *
     * @author Bo Gotthardt
     * @class EditorStatsDAnalytics
     * @constructor
     *
     * @param {String} bucket The bucket name.
     */
    class EditorStatsDAnalytics extends StatsDAnalytics {
        constructor(bucket) {
            super(`${bucket}.editor`);
            this._listener = new EventDispatcher();
            this._listener.listenTo(Backbone.history, "route", this.trackPageView);
        }

        // eslint-disable-next-line class-methods-use-this
        _getPathSuffix() {
            const principal = LoggedIn.principal();
            const userSuffix = principal
                ? `.${principal.get("companyId")}.${principal.get("userId")}`
                : ".unknown.unknown";

            return userSuffix;
        }
    }

    return EditorStatsDAnalytics;
});



// WEBPACK FOOTER //
// ./src/editor/services/tracker/EditorStatsDAnalytics.js